import {UUID} from '../../../shared/types/uuid.type';
import {createAction, props} from '@ngrx/store';
import {DvrRecord, DvrRecordStatus} from '../../../services/api/dvr/dvr.model';

export const loadRecords = createAction(
  '[Records] Load Records'
);

export const loadRecordsSuccess = createAction(
  '[Records] Load Records Success',
  props<{ data: DvrRecord[] }>()
);

export const loadRecordsFailure = createAction(
  '[Records] Load Records Failure',
  props<{ error: any }>()
);

export const recordCreated = createAction(
  '[Records] Record Created',
  props<{ record: DvrRecord }>()
);

export const recordUpdated = createAction(
  '[Records] Record Updated',
  props<{ record: DvrRecord }>()
);

export const recordDeleted = createAction(
  '[Records] Record Deleted',
  props<{ recordId: UUID }>()
);

export const manyRecordsStatusUpdated = createAction(
  '[Records] Many Records Status Updated',
  props<{ ids: UUID[], status: DvrRecordStatus }>()
);

export const manyRecordsDeleted = createAction(
  '[Records] Many Records Deleted',
  props<{ ids: UUID[] }>()
);

export const clearRecordsState = createAction(
  '[Records] Clear Records State'
);
